import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { Form, Field } from 'react-final-form';
import ValidatedField from '../general/ValidatedField';
import { CURRENT_USER_UPDATE } from '../../mutations';
import { CURRENT_USER } from '../../queries';

const normalizeVariables = (variables) =>
  Object.fromEntries(
    Object.entries(variables)
      .filter(([key]) =>
        ['email', 'password', 'passwordConfirmation'].includes(key)
      )
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, value === 'None' ? null : value])
  );

const UserMutation = (props) => {
  let formRef;
  const { formId, initialValues, onCompleted, validate } = props;
  return (
    <Mutation
      mutation={CURRENT_USER_UPDATE}
      onCompleted={() => onCompleted(formRef)}
      refetchQueries={[{ query: CURRENT_USER }]}
    >
      {(mutation) => (
        <Form
          onSubmit={(variables) =>
            mutation({
              variables: normalizeVariables(variables),
            })
          }
          validate={validate}
          initialValues={initialValues}
        >
          {({ handleSubmit, form }) => {
            formRef = form;
            return (
              <form id={formId} onSubmit={handleSubmit}>
                <Field name="id">
                  {(input) => <input {...input} type="hidden" />}
                </Field>
                <ValidatedField name="email" label="Email" />
                <ValidatedField
                  type="password"
                  name="password"
                  label="Password"
                />
                <ValidatedField
                  type="password"
                  name="passwordConfirmation"
                  label="Password Confirmation"
                />
              </form>
            );
          }}
        </Form>
      )}
    </Mutation>
  );
};

const validate = (values) => {
  const { password, passwordConfirmation } = values;
  const errors = {};

  const required = ['email', ...(password ? ['passwordConfirmation'] : [])];
  required.forEach((r) => !values[r] && (errors[r] = 'Required'));

  if (password && password.length < 8)
    errors.password = 'Should be at least 8 characters';

  if (password && passwordConfirmation && password !== passwordConfirmation)
    errors.passwordConfirmation = 'Does not match password';

  return errors;
};

const UserForm = ({ currentUser, onCompleted }) => (
  <UserMutation
    formId="update-user-form"
    initialValues={currentUser}
    onCompleted={onCompleted}
    validate={validate}
  />
);

UserForm.defaultProps = {
  onCompleted: () => {},
};

UserForm.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired,
  onCompleted: PropTypes.func.isRequired,
};

export default UserForm;
